module.exports = __webpack_public_path__ + "static/media/114.3e682a86.jpg";